import apiRoutes from './api.routes';
import ModelService from './model.service';

const ProjectSectionsService = new ModelService(apiRoutes.projectSections, '/projects/items', 'content');

ProjectSectionsService.getImage = (filename, w = false, h = false, c = false) => ProjectSectionsService.getFilePathByDir('/uploads/use-cases', filename, w, h, c);

/** Types */

ProjectSectionsService.TYPE_TEXT_ONLY = 1;
ProjectSectionsService.TYPE_WITH_HASHTAGS = 2;
ProjectSectionsService.TYPE_TWO_COLUMNS = 3;
ProjectSectionsService.TYPE_HIGHLIGHTED = 4;
ProjectSectionsService.TYPE_QUOTE = 5;

ProjectSectionsService.getTypeList = t => ({
  [ProjectSectionsService.TYPE_TEXT_ONLY]: t('Text only'),
  [ProjectSectionsService.TYPE_WITH_HASHTAGS]: t('With hashtags'),
  [ProjectSectionsService.TYPE_TWO_COLUMNS]: t('Two columns'),
  [ProjectSectionsService.TYPE_HIGHLIGHTED]: t('Highlited'),
  [ProjectSectionsService.TYPE_QUOTE]: t('Quote')
});

ProjectSectionsService.getTypeOptions = t => ProjectSectionsService
  .prepareOptionsFromSimpleObject(ProjectSectionsService.getTypeList(t));

ProjectSectionsService.getTypeTitle = (status, t) => {
  const label = ProjectSectionsService.getTypeList(t)[status];
  return label || '-';
};

/** Positions */
ProjectSectionsService.POSITION_HOME = 1;

ProjectSectionsService.getPositionList = t => ({
  [ProjectSectionsService.POSITION_HOME]: t('Home page'),
});

ProjectSectionsService.getPositionOptions = t => ProjectSectionsService
  .prepareOptionsFromSimpleObject(ProjectSectionsService.getPositionList(t));

  ProjectSectionsService.getPositionTitle = (status, t) => {
  const label = ProjectSectionsService.getPositionList(t)[status];
  return label || '-';
};

export default ProjectSectionsService;



// WEBPACK FOOTER //
// ./src/services/projectSections.service.js